<template>
  <div class="locale-changer">
    <v-multiselect
      v-model="locale"
      track-by="lang"
      :searchable="false"
      :hide-selected="true"
      :show-labels="false"
      :placeholder="''"
      :allow-empty="false"
      :options="langs">
      <template slot="caret">
        <span />
      </template>
      <template slot="singleLabel">
        <div class="option__desc">
          <country-flag v-if="$i18n.locale === 'cs'"
                        country="cz"
                        size="small" />
          <country-flag v-else
                        country="gb"
                        size="small" />
        </div>
      </template>
      <template slot="option"
                slot-scope="props">
        <div class="option__desc">
          <country-flag :country="props.option.icon"
                        size="small" />
        </div>
      </template>
    </v-multiselect>
  </div>
</template>

<script>
export default {
  name: 'LocaleChanger',
  data() {
    return {
      langs: [
        {
          lang: 'cs',
          icon: 'cz'
        },
        {
          lang: 'en',
          icon: 'gb'
        }
      ]
    };
  },
  computed: {
    locale: {
      get() {
        return localStorage.getItem('preferredLocale') || this.$i18n.locale || 'cs';
      },
      set(val) {
        this.$i18n.locale = val.lang;
        localStorage.setItem('preferredLocale', val.lang);
      }
    }
  }
};
</script>
<style lang="scss">
@import '@colors';
.locale-changer .multiselect .multiselect__tags {
  background-color: $primary-color;
}

.locale-changer {
  cursor: pointer;
}
</style>
